var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };} /* eslint-disable react/no-multi-comp */
/* eslint-disable react/no-danger */
/* eslint-disable react/no-array-index-key */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { t, I18NLink } from "../../I18N";
import SafeHTML from "../../utils/SafeHTML";
import getFieldLabel from "../../Templates/utils/getFieldLabel";
import Immutable from 'immutable';

const MetadataFieldSnippets = ({ fieldSnippets, documentViewUrl, template, searchTerm = '' }) => /*#__PURE__*/
React.createElement(React.Fragment, null, /*#__PURE__*/
_jsx("li", { className: "snippet-list-item-header metadata-snippet-header" }, void 0, /*#__PURE__*/
_jsx(I18NLink, { to: `${documentViewUrl}?searchTerm=${searchTerm}` }, void 0,
getFieldLabel(fieldSnippets.get('field'), template)
)
),
fieldSnippets.get('texts').map((snippet, index) => /*#__PURE__*/
_jsx("li", { className: "snippet-list-item metadata-snippet" }, index, /*#__PURE__*/
_jsx("span", {}, void 0, /*#__PURE__*/
_jsx(SafeHTML, {}, void 0, snippet)
)
)
)
);











const DocumentContentSnippets = ({
  selectSnippet,
  documentSnippets,
  documentViewUrl,
  searchTerm,
  selectedSnippet
}) => /*#__PURE__*/
React.createElement(React.Fragment, null, /*#__PURE__*/
_jsx("li", { className: "snippet-list-item-header fulltext-snippet-header" }, void 0,
t('System', 'Document contents')
),
documentSnippets.map((snippet, index) => {
  const selected = snippet.get('text') === selectedSnippet.get('text') ? 'selected' : '';
  const filename = snippet.get('filename');
  const page = snippet.get('page');
  return (/*#__PURE__*/
    _jsx("li", { className: `snippet-list-item fulltext-snippet ${selected}` }, index, /*#__PURE__*/
    _jsx(I18NLink, {
      onClick: () => selectSnippet(page, snippet),
      to: `${documentViewUrl}?page=${page}&searchTerm=${searchTerm || ''}${filename ? `&file=${filename}` : ''}` }, void 0, /*#__PURE__*/

    _jsx("span", { className: "page-number" }, void 0, page), /*#__PURE__*/
    _jsx("span", { className: "snippet-text" }, void 0, /*#__PURE__*/
    _jsx(SafeHTML, {}, void 0, snippet.get('text'))
    )
    )
    ));

})
);














const SnippetList = ({
  snippets,
  documentViewUrl,
  searchTerm,
  selectSnippet,
  template,
  selectedSnippet
}) => /*#__PURE__*/
_jsx("ul", { className: "snippet-list" }, void 0,
snippets.get('metadata').map((fieldSnippets) => /*#__PURE__*/
_jsx(MetadataFieldSnippets, {

  fieldSnippets: fieldSnippets,
  template: template,
  documentViewUrl: documentViewUrl,
  searchTerm: searchTerm }, fieldSnippets.get('field')
)
),
snippets.get('fullText').size ? /*#__PURE__*/
_jsx(DocumentContentSnippets, {
  documentSnippets: snippets.get('fullText'),
  documentViewUrl: documentViewUrl,
  selectSnippet: selectSnippet,
  selectedSnippet: selectedSnippet,
  searchTerm: searchTerm }
) :

''

);

















const mapStateToProps = (state, ownProps) => ({
  template: state.templates.find((tmpl) => tmpl.get('_id') === ownProps.doc.get('template')),
  selectedSnippet: state.documentViewer.uiState.get('snippet')
});

export { DocumentContentSnippets, MetadataFieldSnippets, SnippetList, mapStateToProps };
export default connect(mapStateToProps)(SnippetList);